import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=4aebd71a&scoped=true&"
import script from "./QuizPage.vue?vue&type=script&lang=ts&"
export * from "./QuizPage.vue?vue&type=script&lang=ts&"
import style0 from "./QuizPage.vue?vue&type=style&index=0&id=4aebd71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aebd71a",
  null
  
)

export default component.exports